<template>
    <div v-if="rows" class="as-incident as-incident__tennis">
      <div v-if="rows" class="as-incident__head">
        <div class="as-player">
          <PlayerTennis _class="away":scores="playerHomeTeamMaxPoint.totalPoint" :name="mapPlayer(
                  playerHomeTeamMaxPoint.id,
                  props?.detailShooting?.listPlayer
                )?.name" :img="getImgUrlBySport('player', playerHomeTeamMaxPoint?.id as string)" />
        </div>
        <div class="as-player as-player__away">
          <PlayerTennis :scores="playerHomeTeamMaxPoint.totalPoint" :name="mapPlayer(
                  playerAwayTeamMaxPoint.id,
                  props?.detailShooting?.listPlayer
                )?.name" :img="getImgUrlBySport('player', playerAwayTeamMaxPoint?.id as string)" />
        </div>
      </div>

      <div class="as-incident__list">
        <div
          v-for="(row, index) in rows"
          :key="index"
          class="as-incident__item"
        >
          <h3
            @click="changeActiveCollapse(index.toString())"
            :class="{
              'as-active': activeCollapse === index.toString(),
            }"
          >
            <span>{{
              collapses.find((collapse) => collapse.value === index.toString())
                ?.title
            }}</span>
            <ArrowDown fill="#4CF446" />
          </h3>
          <div v-for="data in row" v-show="activeCollapse == index.toString()">
            <div class="as-incident_row">
                <div class="as__left">
                    <div class="as-item-left as-item-left__top">
                        1
                        <div class="as__live">
                            <TennisLive/>
                        </div>
                    </div>
                    <div class="as-item-left as-item-left__bottom">
                        2
                        <div class="as__live">
                            <TennisLive/>
                        </div>
                    </div>
                </div>
                <div class="as__right">
                    <div class="as-item-right as-item-right__top">
                        <span class="as__white">0</span>
                        <span>0</span>
                        <span>0</span>
                        <span>0</span>
                        <span class="as__white">0</span>
                        <span>0</span>
                        <span>0</span>
                        <span>0</span>
                        <span class="as__white">0</span>
                        <span>0</span>
                        <span>0</span>
                        <span>0</span>
                        <span class="as__white">0</span>
                        <span>0</span>
                        <span>0</span>
                        <span>0</span>
                    </div>
                    <div class="as-item-right as-item-right__bottom">
                        <span>0</span>
                        <span>0</span>
                        <span class="as__white">0</span>
                        <span>0</span>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <NoData v-else />
  </template>

  <script setup lang="ts">
  import { defineProps, ref, computed } from "vue";
  import { mapPlayer } from "~src/helpers/basketball";
  import ArrowDown from "~src/components/icons/ArrowDown.vue";
  import IncidentPlayer from "~src/components/incidents/tennis/IncidentPlayer.vue";
  import NoData from "~src/components/NoData.vue";
import TennisLive from "~src/components/icons/TennisLive.vue";
import PlayerTennis from "~src/components/player/PlayerTennis.vue";
  interface IProps {
    isPopup: boolean;
    detailShooting: any;
  }

  const props = withDefaults(defineProps<IProps>(), {
    isPopup: true,
  });

  const findMaxPointPlayer = (listPlayer: Array<any>, teamId: number) => {
    let maxPoint = 0;
    let maxPointPlayer = null;
    if (!listPlayer) return null;
    listPlayer.forEach((player: any) => {
      if (player.teamId === teamId && player.totalPoint > maxPoint) {
        maxPoint = player.point;
        maxPointPlayer = player;
      }
    });
    return maxPointPlayer;
  };

  const playerHomeTeamMaxPoint: any = computed(() =>
    findMaxPointPlayer(props?.detailShooting?.groupByPlayerData, 1)
  );
  const playerAwayTeamMaxPoint: any = computed(() =>
    findMaxPointPlayer(props?.detailShooting?.groupByPlayerData, 2)
  );
  const rows = computed(() => {
    return props?.detailShooting?.shootingPointsConverted;
  });

  const collapses = computed(() => {
    if (!props?.detailShooting?.shootingPointsConverted) return [];
    const data = []
    for (const [key, value] of Object.entries(props?.detailShooting?.shootingPointsConverted) as any) {
      const homePoints = value[value.length - 1][9];
      const awayPoint = value[value.length - 1][10];
      const res: { title: string; value: string } = {
        title:
          key === "4"
            ? `FT ${homePoints} - ${awayPoint}`
            : `H${key} ${homePoints} - ${awayPoint}`,
        value: key as string,
      };
      data.push(res);
    }
    return data.reverse();
  });

  const activeCollapse = ref(collapses?.value[0]?.value) || 0;

  const changeActiveCollapse = (index: any) => {
    if(activeCollapse.value === index) {
      activeCollapse.value = '';
    } else {
      activeCollapse.value = index;
    }
  }
  </script>

<script lang="ts">
export default {};
</script>
